import { forwardRef } from 'react';
import PropTypes from 'prop-types';

import { ContextMenu } from 'src/components/ContextMenu';
import { FieldSelectMenuItem } from 'src/components/FieldSelectMenuItem';
import { GenerationToolItem } from 'src/components/GenerationToolItem';
import { GENERATION_TOOL, getSuggestToolsWithRewriteRelatives } from 'src/data/generationTool';

import { useStyles } from './useStyles';

const MENU_PROPS = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'right',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'right',
  },
  getContentAnchorEl: null,
};

const TOOLS = getSuggestToolsWithRewriteRelatives();

export const ContextMenuGenerationTool = forwardRef(
  ({ classes, renderButton, onChange, disabled }, ref) => {
    const styles = useStyles({ classes });

    return (
      <ContextMenu
        classes={{ menuRoot: styles.menuPaper }}
        ref={ref}
        renderButton={renderButton}
        renderItems={(closeMenu) =>
          TOOLS.map((tool) => (
            <FieldSelectMenuItem
              key={tool}
              value={tool}
              onClick={(event) => {
                onChange(tool);
                closeMenu(event);
              }}
            >
              <GenerationToolItem
                classes={{ label: styles.itemLabel }}
                tool={tool}
                hideDescription={[
                  GENERATION_TOOL.emailSubject,
                  GENERATION_TOOL.emailBody,
                  GENERATION_TOOL.emailPromotionalBody,
                  GENERATION_TOOL.emailColdOutreachBody,
                ].includes(tool)}
              />
            </FieldSelectMenuItem>
          ))
        }
        menuProps={MENU_PROPS}
        disabled={disabled}
      />
    );
  }
);

ContextMenuGenerationTool.propTypes = {
  classes: PropTypes.shape({}),
  renderButton: PropTypes.func,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

ContextMenuGenerationTool.defaultProps = {
  classes: null,
  renderButton: null,
  onChange: null,
  disabled: false,
};
